export default "__VITE_ASSET__BqKsPtXc__"